<img src="./assets/img/404.svg" alt="Page not found image" />
<h5>Oops... it seems the page you're looking for doesn't exist.</h5>
<span><button mat-flat-button routerLink="/" routerLinkActive="active" >Go home</button></span>